module.exports = __webpack_public_path__ + "img/GroupN1.8eb9cb84.png";